import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { useCompany, buildWhatsAppUrl } from "@/lib/useCompany";

const NAV_LINKS = [
  { href: "#servicios", label: "Servicios" },
  { href: "#tipos", label: "Modelos" },
  { href: "#calidad", label: "Calidad" },
  { href: "#cotizar", label: "Cotizar" },
  { href: "#contacto", label: "Contacto" },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const company = useCompany();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed inset-x-0 top-0 z-50 bg-vp-navy border-b-2 ${
        scrolled ? "border-vp-yellow" : "border-white/15"
      } transition-colors`}
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 h-16 lg:h-20 flex items-center justify-between">
        <Link
          to="/"
          data-testid="logo-link"
          className="flex items-center gap-3 group"
        >
          <img
            src="/logo-vigopal.png"
            alt="Vigopal"
            className="w-10 h-10 lg:w-11 lg:h-11 object-contain border-2 border-vp-yellow group-hover:border-white transition-colors"
          />
          <span className="heading-industrial text-2xl tracking-tighter text-white">
            VIGOPAL
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-10">
          {NAV_LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-${l.label.toLowerCase()}`}
              className="text-xs font-bold tracking-[0.18em] uppercase text-white/70 hover:text-vp-yellow transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          <a
            href={buildWhatsAppUrl(company.whatsapp)}
            target="_blank"
            rel="noreferrer"
            data-testid="header-whatsapp-btn"
            className="bg-vp-red hover:bg-[#b51e13] text-white font-bold uppercase tracking-widest text-xs px-6 py-3 transition-colors"
          >
            WhatsApp
          </a>
        </div>

        <button
          type="button"
          aria-label="Menú"
          data-testid="mobile-menu-toggle"
          onClick={() => setOpen((v) => !v)}
          className="md:hidden p-2 border-2 border-vp-yellow text-white"
        >
          {open ? <X size={18} /> : <Menu size={18} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t-2 border-vp-yellow bg-vp-navy">
          <div className="px-6 py-4 flex flex-col gap-3">
            {NAV_LINKS.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                data-testid={`mobile-nav-${l.label.toLowerCase()}`}
                className="text-xs font-bold tracking-[0.18em] uppercase text-white py-2 border-b border-white/15"
              >
                {l.label}
              </a>
            ))}
            <a
              href={buildWhatsAppUrl(company.whatsapp)}
              target="_blank"
              rel="noreferrer"
              data-testid="mobile-header-whatsapp-btn"
              className="mt-2 bg-vp-red text-white font-bold uppercase tracking-widest text-xs px-6 py-3 text-center"
            >
              WhatsApp Corporativo
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
